<template>
  <div v-if="filteredProducts" class="main">
    <Loading :visible="loading" type="fullPage" size="large" />
    <div class="productList" v-if="Object.keys(filteredProducts).length > 0">
      <div class="productItem" v-for="id in filteredOrder" :key="id">
        <router-link class="productLink linkBlock" :to="routerLink(filteredProducts[id].id)">
          <div class="imageContainer">
            <ImageC
              v-if="filteredProducts[id].images[0]"
              :srcSuffix="`${filteredProducts[id].images[0]}`"
              @load="imageLoaded"
            ></ImageC>
            <!--img v-if="filteredProducts[id].images[0]"
          :src="`${publicURL}420/${filteredProducts[id].images[0]}`" @load="imageLoaded" -->
          </div>
          <div class="text">
            <div class="titleAndCategory">
              <div class="title">
                <div class="price priceInline">
                  {{ formatCurrency(filteredProducts[id].price) }}
                </div>
                {{ filteredProducts[id].name }}
              </div>
              <div class="soldout" v-if="parseInt(filteredProducts[id].stock, 10) <= 0">
                {{ $t('MERCHANDISE_SOLDOUT') }}
              </div>
              <div class="categories">
                <span v-for="category in filteredProducts[id].custom_groups" :key="category.id">{{
                  category.name
                }}</span>
              </div>
              <div class="description">{{ filteredProducts[id].description_short }}</div>
            </div>
            <div class="price priceBelow">{{ formatCurrency(filteredProducts[id].price) }}</div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import formater from '../../lib/formater';
import Loading from '../Loading.vue';
import ImageC from '../ImageC.vue';
import { setPageTitle } from '../../lib/pageTitle';
import { useSeoMeta } from '@unhead/vue';

export default {
  name: 'ProductList',
  data() {
    return {
      maxImageHeight: 0,
      navName: '',
    };
  },
  components: {
    Loading,
    ImageC,
  },
  computed: {
    ...mapState({
      loading: (state) => state.products.isLoading,
      language: (state) => state.language,
      currencySymbol: (state) => state.app.currencySymbol,
      order: (state) => state.products.order,
      userLoaded: (state) => state.user.loaded,
      publicURL: (state) => state.app.API_PUBLIC_URL,
      meta: (state) => state.meta.data,
      navTranslations: (state) => state.app.navTranslations,
    }),
    filteredOrder() {
      const filteredOrder = this.order.filter((id) => {
        return this.filteredProducts[id];
      });
      return filteredOrder;
    },
    ...mapGetters({
      filteredProducts: 'products/filteredList',
    }),
  },
  methods: {
    routerLink(id) {
      if (this.$route.name === 'passes') {
        return { name: 'pass', params: { id: id } };
      }
      return { name: 'product', params: { id: id } };
    },
    formatCurrency(val) {
      return formater.currency(val);
    },
    imageLoaded(e) {
      if (e.height > this.maxImageHeight) {
        this.maxImageHeight = e.height;
      }
      e.classList.add('loaded');
    },
    getNavName(type) {
      if (typeof this.navTranslations !== 'undefined') {
        if (typeof this.navTranslations[type] !== 'undefined') {
          if (
            typeof this.navTranslations[type][this.language] !== 'undefined' &&
            this.navTranslations[type][this.language] !== ''
          ) {
            return this.navTranslations[type][this.language];
          }
        }
      }
      return this.$t(type);
    },
    setMeta() {
      let title = '';
      let description = '';
      let keywords = '';
      let image = '';
      if (typeof this.meta !== 'undefined') {
        if (typeof this.meta.merchandise !== 'undefined') {
          description = this.meta.merchandise.description;
          keywords = this.meta.merchandise.keywords;
          if (this.meta.merchandise.image) {
            image = `${this.publicURL}1200/${this.meta.merchandise.image}`;
          }
          title = this.meta.merchandise.title;
        }

        useSeoMeta({
          title: setPageTitle(title),
          ogTitle: setPageTitle(title),
          description,
          keywords,
          ogDescription: description,
          ogImage: image,
        });
      }
    },
  },
  watch: {
    meta() {
      this.setMeta();
    },
  },
  mounted() {
    this.setMeta();
    this.navName = 'NAV_MERCHANDISE';
    if (this.$route.name === 'passes') {
      this.navName = 'NAV_MEMCARD';
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/grid';
@import '../../scss/mixins';
@import '../../scss/scaffolding'; // img-responsive

.main {
  clear: both;
}

.productList {
  @include blockPadding;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;

  background-color: $block-color;
  display: flex;
  flex-wrap: wrap;
  @if ($block-color != 'transparent') {
    padding-top: 3 * $sp;
  }
}
.productItem > a {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  color: $text-color;
  text-decoration: none;
}
.productItem {
  width: calc(100% / 4);
  padding-left: $sp;
  padding-right: $sp;
  display: flex;
  vertical-align: top;
  margin-bottom: $sp * 3;

  @media screen and (max-width: $screen-lg) {
    width: calc(100% / 3);
  }

  @media screen and (max-width: $screen-md) {
    width: calc(100% / 2);
  }
  @media screen and (max-width: $screen-sm) {
    width: calc(100% / 2);
  }
  @media screen and (max-width: $screen-xs) {
    width: 100%;
  }
  .imageContainer {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: $sp;
  }
  img {
    @extend .img-responsive;
    width: 100%;
  }
  a:hover {
    text-decoration: none;
  }
  a:hover .title {
    text-decoration: underline;
  }
  .titleAndCategory {
    width: 100%;
    align-self: baseline;
  }
  .text {
    margin-top: 8px;
    min-height: 9em;
    vertical-align: top;
    display: flex;
    flex-direction: column;
  }
  .title {
    text-decoration: underline;
    .priceInline {
      float: right;
    }
  }
}
.price {
  padding-left: $sp;
  font-weight: 600;
  white-space: nowrap;
}
.price.priceBelow {
  display: none;
  padding-left: 0;
  text-decoration: none;
}
@media screen and (max-width: $screen-md) {
  .price.priceInline {
    display: none;
  }
  .price.priceBelow {
    display: block;
  }
}

img {
  opacity: 0;
  transition: opacity 0.5s;
}
img.loaded {
  opacity: 1;
}
.productLink {
  width: 100%;
}
.categories {
  font-weight: bold;
}
.categories span:not(:last-child):after {
  content: ', ';
}

.soldout {
  color: $brand-danger;
}
</style>
